import React from "react";

interface RightLeftLayoutIconProps {
  size?: number | string;
  color?: string;
  className?: string;
  onClick?: () => void;
}

const RightLeftLayoutIcon: React.FC<RightLeftLayoutIconProps> = ({ size = 22, color = '#1E1F22', className, onClick }) => (
  <svg width="353" height="36" viewBox="0 0 353 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="353" height="36" rx="3" fill="white" />
    <g clip-path="url(#clip0_188_10711)">
      <rect x="15" y="13" width="58" height="10" fill="#2D6FFF" fillOpacity="0.5" />
      <rect x="80" y="13" width="58" height="10" fill="#2D6FFF" fillOpacity="0.5" />
    </g>
    <rect x="318" y="8" width="20" height="20" fill="#2D6FFF" fillOpacity="0.5" />
    <defs>
      <clipPath id="clip0_188_10711">
        <rect width="123" height="5" fill="white" transform="translate(15 15.5)" />
      </clipPath>
    </defs>
  </svg>


);

export default RightLeftLayoutIcon;
